import script from "./ossImg.vue?vue&type=script&setup=true&lang=js"
export * from "./ossImg.vue?vue&type=script&setup=true&lang=js"

import "./ossImg.vue?vue&type=style&index=0&id=03cf7c86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03cf7c86"]])

export default __exports__